import { QueryClient } from 'react-query';

const queryCache = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0,
      cacheTime: 1000 * 60 * 60 * 24,
    },
  },
});

export default queryCache;
